module.exports = __webpack_public_path__ + "img/behpardakht.5cc3f3a5.png";